import React from "react";
import { Link } from "react-router-dom";
import { SITE_EMAILS } from "../lib/siteConfig";

const SECTIONS = [
  {
    title: "Maximum refund",
    body: [
      "Cancel at least 24 hours before your scheduled pick-up time for the maximum refund. Original booking taxes are returned. Z-Cars retains 10% of the original platform fee and, when an Airalo SIM was secured, its converted provider cost. Your cancellation quote shows only the total amount retained, not a line-item breakdown. Refunds are returned to your original payment method within 5–10 business days.",
    ],
  },
  {
    title: "Late cancellation (within 24 hours)",
    body: [
      "Cancellations made 6–24 hours before pick-up refund 50% of base rental, plus taxes and any one-way or after-hours pick-up/return fees. Platform fees and coupons are not refunded in this tier. If ZCT helped fund the booking, the refundable value is returned proportionally between cash and ZCT.",
    ],
  },
  {
    title: "Last-minute cancellation (within 6 hours)",
    body: [
      "Cancellations within 6 hours of pick-up are non-refundable. If you believe exceptional circumstances apply (medical emergency, airline disruption), contact support with documentation.",
    ],
  },
  {
    title: "Host cancellation",
    body: [
      "If a host cancels a confirmed booking, you receive a full refund and we help you find a comparable vehicle when possible. Repeat host cancellations may affect listing visibility.",
    ],
  },
  {
    title: "No-shows",
    body: [
      "If you do not arrive within 2 hours of the scheduled pick-up without contacting the host, the booking may be marked as a no-show and is non-refundable.",
    ],
  },
];

export default function Cancellation() {
  return (
    <div className="max-w-[760px] mx-auto px-6 lg:px-10 py-12" data-testid="cancellation-page">
      <div className="eyebrow mb-2">Policies</div>
      <h1 className="zc-headline text-4xl md:text-5xl">Cancellation policy</h1>
      <p className="text-[var(--zc-text-2)] mt-4">
        Applies to vehicle rentals booked on Z-Cars. Parking and fractional investments have separate terms.
      </p>

      <div className="mt-10 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.title} className="zc-card p-6">
            <h2 className="zc-headline text-xl">{s.title}</h2>
            {s.body.map((p, i) => (
              <p key={i} className="text-sm text-[var(--zc-text-2)] mt-3 leading-relaxed">{p}</p>
            ))}
          </section>
        ))}
      </div>

      <p className="text-sm text-[var(--zc-text-3)] mt-10">
        Questions? Email{" "}
        <a href={`mailto:${SITE_EMAILS.support}`} className="text-[var(--zc-accent)] font-semibold">
          {SITE_EMAILS.support}
        </a>
        {" "}or see our{" "}
        <Link to="/terms" className="text-[var(--zc-accent)] font-semibold">Terms & privacy</Link>.
      </p>
    </div>
  );
}
